// 顶部横幅轮播功能
(function() {
    function initCarousel() {
        const carouselWrapper = document.querySelector('[data-top-banner-carousel-wrapper]');
        if (!carouselWrapper) return;
        
        const allItems = carouselWrapper.querySelectorAll('[data-top-banner-carousel-item]:not([data-top-banner-carousel-duplicate])');
        if (allItems.length === 0) return;
        
        // 获取可见的横幅项（排除被CSS隐藏的）
        function getVisibleItems() {
            return Array.from(allItems).filter(item => {
                const style = window.getComputedStyle(item);
                return style.display !== 'none' && item.offsetHeight > 0;
            });
        }
        
        let items = getVisibleItems();
        if (items.length === 0) return;
        
        // 实际项目数量（不包括重复项和隐藏项）
        let actualItemCount = items.length;
        
        let currentIndex = 0;
        let itemHeight = 0;
        const interval = 3000; // 3秒切换一次
        let autoSlide;
        let isTransitioning = false;
        
        // 获取实际的项目高度
        function getItemHeight() {
            const visibleItems = getVisibleItems();
            if (visibleItems.length > 0 && visibleItems[0].offsetHeight > 0) {
                return visibleItems[0].offsetHeight;
            }
            return 24; // 默认高度
        }
        
        function updateCarousel(instant = false) {
            itemHeight = getItemHeight();
            const translateY = -currentIndex * itemHeight;
            
            if (instant) {
                carouselWrapper.style.transition = 'none';
            } else {
                carouselWrapper.style.transition = 'transform 0.5s ease-in-out';
            }
            
            carouselWrapper.style.transform = `translateY(${translateY}px)`;
        }
        
        function nextSlide() {
            if (isTransitioning) return;
            
            currentIndex++;
            
            // 如果到达重复的第一项（即最后一个实际项的下一个），无缝跳转到真正的第一项
            if (currentIndex >= actualItemCount) {
                // 先移动到重复项（带动画）
                updateCarousel(false);
                
                // 等待动画完成后，无缝跳转到第一项（无动画）
                isTransitioning = true;
                setTimeout(() => {
                    currentIndex = 0;
                    updateCarousel(true);
                    isTransitioning = false;
                }, 500); // 等待过渡动画完成
            } else {
                updateCarousel(false);
            }
        }
        
        function startAutoSlide() {
            if (autoSlide) {
                clearInterval(autoSlide);
            }
            autoSlide = setInterval(nextSlide, interval);
        }
        
        function stopAutoSlide() {
            if (autoSlide) {
                clearInterval(autoSlide);
                autoSlide = null;
            }
        }
        
        // 初始化 - 确保从第一项开始
        currentIndex = 0;
        // 等待一帧确保DOM渲染完成
        requestAnimationFrame(() => {
            updateCarousel(true);
            startAutoSlide();
        });
        
        // 鼠标悬停时暂停
        const carousel = carouselWrapper.parentElement;
        if (carousel) {
            carousel.addEventListener('mouseenter', stopAutoSlide);
            carousel.addEventListener('mouseleave', startAutoSlide);
        }
        
        // 窗口大小改变时重新计算可见项和位置
        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // 重新计算可见的横幅项
                items = getVisibleItems();
                const newItemCount = items.length;
                
                // 如果可见项数量发生变化，调整索引
                if (newItemCount !== actualItemCount) {
                    // 重置索引，避免超出范围
                    currentIndex = Math.min(currentIndex, Math.max(0, newItemCount - 1));
                    actualItemCount = newItemCount;
                }
                
                updateCarousel(true);
            }, 100);
        });
    }
    
    // 确保DOM加载完成后执行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCarousel);
    } else {
        // DOM已经加载完成
        initCarousel();
    }
})();

